module.exports = __webpack_public_path__ + "img/consultoria_16-9_960.7b62b69c.webp";